import React from 'react';
import { Button } from '../ui/button';
import { ArrowRight, Play } from 'lucide-react';
import CalendlyPopup from '../CalendlyPopup';
import { useCalendlyAndVideo } from '../../hooks/useCalendlyAndVideo';

const EngineCTA = () => {
  const { isCalendlyOpen, openCalendly, closeCalendly } = useCalendlyAndVideo();

  return (
    <section className="py-20 px-6 relative">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
          Traain Once. <span className="text-cyan-400">Execute Everywhere.</span>
        </h2>
        
        <p className="text-xl text-gray-300 mb-4 leading-relaxed">
          Traain Engine gives leaders confidence that Training is aligned, current, and scalable — no matter how the workforce evolves.
        </p>
        
        <p className="text-xl text-gray-300 mb-12">
          Build predictable, compliant, high-performing teams with Traain Engine.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            onClick={openCalendly}
            className="h-14 bg-cyan-500 text-black hover:bg-cyan-400 rounded-lg px-8 text-lg font-semibold transition-all duration-200 hover:scale-105 hover:shadow-lg hover:shadow-cyan-500/50"
            data-testid="engine-cta-demo-btn"
          >
            Schedule a Discovery Call
            <ArrowRight className="w-5 h-5 ml-2" />
          </Button>
          <Button
            size="lg"
            variant="outline"
            onClick={openCalendly}
            className="h-14 border-2 border-cyan-500 text-cyan-400 hover:bg-cyan-500/10 hover:border-cyan-400 rounded-lg px-8 text-lg transition-all duration-200"
            data-testid="engine-cta-action-btn"
          >
            <Play className="w-5 h-5 mr-2" />
            See Traain in Action
          </Button>
        </div>
      </div>
      
      <CalendlyPopup isOpen={isCalendlyOpen} onClose={closeCalendly} />
    </section>
  );
};

export default EngineCTA;
